import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-501-fill",
  "use": "icon-501-fill-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" class=\"qi-501-fill\" viewBox=\"0 0 16 16\" id=\"icon-501-fill\">\n  <path d=\"M12.315 3.086a3.146 3.146 0 0 0-.396.04 4.675 4.675 0 0 0-7.838 0 3.146 3.146 0 0 0-.396-.04 3.184 3.184 0 1 0 1.243 6.116 4.61 4.61 0 0 0 6.144 0 3.185 3.185 0 1 0 1.243-6.116zm1.187 8.214H4.525a.5.5 0 0 0 0 1h8.977a.5.5 0 0 0 0-1zm-2.518 2.313a.5.5 0 0 0-.5-.5H1.508a.5.5 0 0 0 0 1h8.976a.5.5 0 0 0 .5-.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol